import React from 'react';

import { noop } from 'buyside/util/lodashAlt';

type AccordionProps = {
  isExpanded: boolean;
  toggleExpand: (e: React.MouseEvent) => void;
};

export const AccordionContext = React.createContext<AccordionProps>({
  isExpanded: false,
  toggleExpand: noop
});

export const useAccordionContext = (): AccordionProps => React.useContext(AccordionContext);
